import React from 'react';
import ReactDOM from 'react-dom/client';
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n'; // Importa la configurazione i18n

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	// <React.StrictMode>
		<FluentProvider theme={webLightTheme}>
			{/* <Router>
				<Routes>
					<Route element={<Login />} />
					<Route index path="/" element={<DashboardLayout />} />
					<Route path="orders" element={<Orders />} />
					<Route path="profile" element={<Profile />} />
					<Route path="/order/:id" element={<OrderPageSupplier />} />
					<Route path="/elements" element={<Elements />} />
				</Routes>
			</Router> */}

			<App />
		</FluentProvider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
